if (!customElements.get('bitig-home-discovery')) {
  customElements.define('bitig-home-discovery', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      if (!this.tabs.length) return;
      this.dataset.ready = 'true';
      this.rotateBooks();
      const activate = tab => {
        this.tabs.forEach(item => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
          this.querySelector(`#${item.getAttribute('aria-controls')}`).hidden = !active;
        });
      };
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', event => {
          const rtl = getComputedStyle(this).direction === 'rtl';
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.tabs.length - 1
            : event.key === 'ArrowRight' ? (index + (rtl ? -1 : 1) + this.tabs.length) % this.tabs.length
            : event.key === 'ArrowLeft' ? (index + (rtl ? 1 : -1) + this.tabs.length) % this.tabs.length : null;
          if (next === null) return;
          event.preventDefault();
          activate(this.tabs[next]);
          this.tabs[next].focus();
        });
      });
    }

    rotateBooks() {
      this.querySelectorAll('template[data-bitig-intro-pool]').forEach(pool => {
        const grid = pool.closest('.bitig-intro-panel')?.querySelector('.bitig-intro-products');
        const cards = [...pool.content.querySelectorAll('[data-bitig-book-id]')];
        if (!grid || !cards.length) return;
        const count = Math.min(4, cards.length);
        const storageKey = 'bitig:intro:' + pool.dataset.bitigIntroPool;
        let previous = [];
        try {
          const saved = JSON.parse(sessionStorage.getItem(storageKey) || '[]');
          if (Array.isArray(saved)) previous = saved;
        } catch (_) { /* Rotation still works when browser storage is unavailable. */ }
        const previousIds = new Set(previous);
        const shuffle = items => {
          for (let i = items.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [items[i], items[j]] = [items[j], items[i]];
          }
          return items;
        };
        // Prefer a completely new selection; reuse only if fewer than eight books remain in stock.
        const fresh = shuffle(cards.filter(card => !previousIds.has(card.dataset.bitigBookId)));
        const selected = fresh.slice(0, count);
        if (selected.length < count) {
          const repeats = shuffle(cards.filter(card => previousIds.has(card.dataset.bitigBookId)));
          selected.push(...repeats.slice(0, count - selected.length));
        }
        grid.replaceChildren(...selected.map(card => card.cloneNode(true)));
        try {
          sessionStorage.setItem(storageKey, JSON.stringify(selected.map(card => card.dataset.bitigBookId)));
        } catch (_) { /* Keep the selected books visible even when storage is blocked. */ }
      });
    }
  });
}
